export default __webpack_public_path__ + "static/media/welcomimg.4b6fe72e.png";